module.exports = __webpack_public_path__ + "img/twitter.0f1a090c.svg";